// Music theory + shared constants for the audio engine.

export const EQ_FREQS = [60, 150, 400, 1000, 2400, 6000, 12000, 16000];
export const EQ_LABELS = ["60", "150", "400", "1k", "2.4k", "6k", "12k", "16k"];

const NOTE_PC = { c: 0, "c#": 1, db: 1, d: 2, "d#": 3, eb: 3, e: 4, f: 5, "f#": 6, gb: 6, g: 7, "g#": 8, ab: 8, a: 9, "a#": 10, bb: 10, b: 11 };
const SCALE_INTERVALS = {
  major: [0, 2, 4, 5, 7, 9, 11],
  minor: [0, 2, 3, 5, 7, 8, 10],
  dorian: [0, 2, 3, 5, 7, 9, 10],
  phrygian: [0, 1, 3, 5, 7, 8, 10],
  mixolydian: [0, 2, 4, 5, 7, 9, 10],
  lydian: [0, 2, 4, 6, 7, 9, 11],
  harmonicminor: [0, 2, 3, 5, 7, 8, 11],
  minorpentatonic: [0, 3, 5, 7, 10],
  majorpentatonic: [0, 2, 4, 7, 9],
  blues: [0, 3, 5, 6, 7, 10],
};

// Parse a key string ("F minor") into the set of allowed pitch classes.
export function parseKeyToAllowed(keyStr) {
  if (!keyStr || typeof keyStr !== "string") return null;
  const m = keyStr.trim().toLowerCase().match(/^([a-g][#b]?)\s*(.*)$/);
  if (!m) return null;
  const root = NOTE_PC[m[1]];
  if (root == null) return null;
  const t = m[2];
  let mode = "major";
  if (/dorian/.test(t)) mode = "dorian";
  else if (/phrygian/.test(t)) mode = "phrygian";
  else if (/mixolyd/.test(t)) mode = "mixolydian";
  else if (/lydian/.test(t)) mode = "lydian";
  else if (/harmonic/.test(t)) mode = "harmonicminor";
  else if (/pentatonic/.test(t)) mode = /min/.test(t) ? "minorpentatonic" : "majorpentatonic";
  else if (/blues/.test(t)) mode = "blues";
  else if (/(min|aeolian|^m$|dorian)/.test(t) || /\bm\b/.test(t)) mode = "minor";
  const set = new Set(SCALE_INTERVALS[mode].map((i) => (root + i) % 12));
  return set;
}

// Root pitch class from a key string (for building chords/stabs), or null.
export function parseKeyRoot(keyStr) {
  if (!keyStr || typeof keyStr !== "string") return null;
  const m = keyStr.trim().toLowerCase().match(/^([a-g][#b]?)/);
  if (!m) return null;
  const pc = NOTE_PC[m[1]];
  return pc == null ? null : pc;
}

export function keyIsMinor(keyStr) {
  const t = (keyStr || "").toLowerCase();
  return /(min|aeolian|dorian|phrygian|harmonic)/.test(t) || /\bm\b/.test(t);
}

// Nudge a midi note to the nearest note inside the allowed scale.
export function snapMidiToScale(midi, allowed) {
  if (!allowed || allowed.has(((midi % 12) + 12) % 12)) return midi;
  for (let d = 1; d <= 6; d++) {
    if (allowed.has((((midi - d) % 12) + 12) % 12)) return midi - d;
    if (allowed.has((((midi + d) % 12) + 12) % 12)) return midi + d;
  }
  return midi;
}

export function midiToFreq(m) {
  return 440 * Math.pow(2, (m - 69) / 12);
}
